import { render, staticRenderFns } from "./DepositHistory.vue?vue&type=template&id=62678bd7&scoped=true&"
import script from "./DepositHistory.vue?vue&type=script&lang=ts&"
export * from "./DepositHistory.vue?vue&type=script&lang=ts&"
import style0 from "./DepositHistory.vue?vue&type=style&index=0&id=62678bd7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62678bd7",
  null
  
)

export default component.exports